import TextareaContentEditable from "./TextareaContentEditable";

export default TextareaContentEditable;
export { TextareaContentEditable };
